import {CSSProperties, FC} from 'react';


export interface IIconNavigationSmallProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconNavigationSmall: FC<IIconNavigationSmallProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 25"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M15.8 7.788c-.033.013-1.77.639-3.86 1.393-2.09.755-3.9 1.409-4.022 1.455-.25.094-.483.309-.576.533-.034.082-.062.26-.062.397 0 .297.101.534.303.712.076.066.797.45 1.601.851l1.464.731.74 1.48c.407.814.788 1.531.846 1.594.187.2.395.284.706.284.402 0 .701-.178.871-.518.033-.066.701-1.897 1.484-4.068 1.472-4.077 1.49-4.135 1.382-4.419-.119-.315-.576-.536-.877-.425M14.682 9.97c-.069.197-1.737 4.82-1.786 4.95-.013.036-.237-.367-.549-.987-.29-.576-.567-1.089-.615-1.14-.048-.051-.557-.327-1.13-.612-.573-.286-1.042-.531-1.042-.544 0-.026 5.065-1.87 5.148-1.875.033-.001.026.06-.026.208" />
        </svg>
    );
};
